exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".host[data-v-69506c94] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}", ""]);

// exports
